export default function PhoneIcon() {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18.12 11.2501C17.69 11.2501 17.35 10.9001 17.35 10.4801C17.35 10.1101 16.98 9.3401 16.36 8.6701C15.75 8.0201 15.08 7.6401 14.52 7.6401C14.09 7.6401 13.75 7.2901 13.75 6.8701C13.75 6.4501 14.1 6.1001 14.52 6.1001C15.52 6.1001 16.57 6.6401 17.49 7.6101C18.35 8.5201 18.9 9.6501 18.9 10.4701C18.9 10.9001 18.55 11.2501 18.12 11.2501Z"
        fill="white"
      />
      <path
        d="M21.73 11.25C21.3 11.25 20.96 10.9 20.96 10.48C20.96 6.93 18.07 4.05 14.53 4.05C14.1 4.05 13.76 3.7 13.76 3.28C13.76 2.86 14.1 2.5 14.52 2.5C18.92 2.5 22.5 6.08 22.5 10.48C22.5 10.9 22.15 11.25 21.73 11.25Z"
        fill="white"
      />
      <path
        opacity="0.4"
        d="M12.29 14.71L9.02 17.98C8.66 17.66 8.31 17.33 7.97 16.99C6.94 15.95 6.01 14.86 5.18 13.72C4.36 12.58 3.7 11.44 3.22 10.31C2.74 9.17 2.5 8.08 2.5 7.04C2.5 6.36 2.62 5.71 2.86 5.11C3.1 4.5 3.48 3.94 4.01 3.44C4.65 2.81 5.35 2.5 6.09 2.5C6.37 2.5 6.65 2.56 6.9 2.68C7.16 2.8 7.39 2.98 7.57 3.24L9.89 6.51C10.07 6.76 10.2 6.99 10.29 7.21C10.38 7.42 10.43 7.63 10.43 7.82C10.43 8.06 10.36 8.3 10.22 8.53C10.09 8.76 9.9 9 9.66 9.24L8.9 10.03C8.79 10.14 8.74 10.27 8.74 10.43C8.74 10.51 8.75 10.58 8.77 10.66C8.8 10.74 8.83 10.8 8.85 10.86C9.03 11.19 9.34 11.62 9.78 12.14C10.23 12.66 10.71 13.19 11.23 13.72C11.59 14.07 11.94 14.41 12.29 14.71Z"
        fill="white"
      />
      <path
        d="M22.4696 18.83C22.4696 19.11 22.4196 19.4 22.3196 19.68C22.2896 19.76 22.2596 19.84 22.2196 19.92C22.0496 20.28 21.8296 20.62 21.5396 20.94C21.0496 21.48 20.5096 21.87 19.8996 22.12C19.8896 22.12 19.8796 22.13 19.8696 22.13C19.2796 22.37 18.6396 22.5 17.9496 22.5C16.9296 22.5 15.8396 22.26 14.6896 21.77C13.5396 21.28 12.3896 20.62 11.2496 19.79C10.8596 19.5 10.4696 19.21 10.0996 18.9L13.3696 15.63C13.6496 15.84 13.8996 16 14.1096 16.11C14.1596 16.13 14.2196 16.16 14.2896 16.19C14.3696 16.22 14.4496 16.23 14.5396 16.23C14.7096 16.23 14.8396 16.17 14.9496 16.06L15.7096 15.31C15.9596 15.06 16.1996 14.87 16.4296 14.75C16.6596 14.61 16.8896 14.54 17.1396 14.54C17.3296 14.54 17.5296 14.58 17.7496 14.67C17.9696 14.76 18.1996 14.89 18.4496 15.06L21.7596 17.41C22.0196 17.59 22.1996 17.8 22.3096 18.05C22.4096 18.3 22.4696 18.55 22.4696 18.83Z"
        fill="white"
      />
    </svg>
  );
}
